import React, { useEffect, useRef, useState } from 'react'
import Sport1 from '../assets/Sports1.png'
import Sport2 from '../assets/Sports2.png'
import Sport3 from '../assets/Sports3.png'
import Sport4 from '../assets/Sports4.png'
import circleGirl from '../assets/singlepodcast3.png'
import { useContext } from 'react'
import { EventsContext } from '../context/EventsContext'
import { useLocation, useNavigate } from 'react-router-dom'
import { NavbarContext } from '../context/NavbarContext'
import { TbHeartPlus } from "react-icons/tb";
import { IoShareSocialOutline } from "react-icons/io5";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAppData } from '../apiService'
import { ShimmerButton, ShimmerPostItem, ShimmerThumbnail } from 'react-shimmer-effects'

function Albums() {
  const { albumId, setAlbumId, allAlbums } = useContext(EventsContext);
  const { navHeading, setNavHeading } = useContext(NavbarContext)
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [allAlbums,setAllAlbums] = useState(null)

  const navigate = useNavigate();
  const location = useLocation();
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    rows: 1,
    arrows: false,
  };
  const slidersssRef = useRef(null);

  //  useEffect(() => {
  //           const fetchData = async () => { 
  //             setLoading(true)
  //             try {
  //               const result = await getAppData("api.php?set=Album&page=1&offset=5000&uid=1");
  //               // console.log(result.result);

  //               if(result.success == 1){
  //                 setAllAlbums(result.result.data);
  //               }
  //             }  catch (err) {
  //               setError('Error fetching data. Please try again later.');
  //               console.error('Error:', err);
  //             } finally {
  //               setLoading(false);
  //             }

  //           };

  //           fetchData();
  //         }, []);

  if (!allAlbums) {
    return (
      // <div className="loader-container">
      //     <div className="dot-wave-loader">
      //         <div></div>
      //         <div></div>
      //         <div></div>
      //         <div></div>
      //         <div></div>
      //     </div>
      // </div>
      <>
        <div className='layout7-div'>

          <div className='shimmer-albums-for-laptop'>
            <p className='spacial-albums-for-phone-secreen-imp' style={{ display: "flex" }}> <span>Albums</span></p>
            <div className='slider-container55' >
              <div className='slider-wrapper55'>
                <div style={{ display: "flex", justifyContent: "center" }} className='albums-shimmer-post-items'>

                  {/* <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"30px !important"}} />
<ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} />
<ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"0px"}} /> */}
                  <ShimmerThumbnail width={200} /><ShimmerThumbnail width={200} />
                </div>
              </div>
              <button className="slider-arrow55 right55" onClick={() => slidersssRef.current.slickNext()}>
                <span style={{ marginRight: "5px" }}>More...</span><MdOutlineKeyboardDoubleArrowRight />
              </button>
            </div>
          </div>
          <div className='shimmer-albums-for-mobile'>
            {/* <ShimmerPostItem card text imageType="thumbnail" style={{marginTop:"30px !important"}} />
               */}
            <ShimmerThumbnail height={300} />
            <p className='spacial-albums-for-phone-secreen-imp' style={{ display: "flex", marginTop: "20px" }}> <span>Albums</span></p>
            <div className='Albums-main-div2333333'>
              {/* <ShimmerPostItem card text imageType="thumbnail" />
<ShimmerPostItem card text imageType="thumbnail"  />
<ShimmerPostItem card text imageType="thumbnail"  /> */}
              <div className='Albums-single-div'><ShimmerThumbnail width={135} height={120} /></div>
              <div className='Albums-single-div'><ShimmerThumbnail width={135} height={120} /></div>
              <div className='Albums-single-div'><ShimmerThumbnail width={135} height={120} /></div>
            </div>
          </div>
        </div>

      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }



  //   const allAlbums = [
  //     { id: "hjkllihdvhjt4311", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4322", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4333", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4344", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4315", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4326", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4337", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4348", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4319", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4320", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4331", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4342", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4313", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4324", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4335", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4346", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4317", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4328", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4339", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4341", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4312", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4323", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4334", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4345", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4316", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4327", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4338", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4349", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },

  // ]


  const handleClick = (id) => {

    const present = allAlbums.find((item) => item.id == id);
    if (present) {
      setAlbumId(id);
      setNavHeading()
      navigate("/myalbum");
    } else {
      setAlbumId(null)
      navigate("/myalbum");
    }

  }

  return (
    <>
      {allAlbums ? <div className='layout7-div'>
        {/* <div className='Albums-main-div'>
        {allAlbums.map((item)=>(
          <div className='Albums-single-div' key={item.id} onClick={()=>handleClick(item.id)}>
          <div className='albums-div-for-image' style={{backgroundImage:`url(${item.feature_image})`}}></div>
          <p className='albums-p-para1'>{item.title}</p>
          <p className='albums-p-para2'>{item.time}</p>
        </div>
        ))}


      </div> */}

        <div className='Albums-main-div-for-phone-screen'>
          <div className='Albums-single-div-for-phonesecreen' onClick={() => handleClick(allAlbums[0].id)}>
            <div className='albums-div-for-image-for-phonesecreen'>
              <img src={allAlbums[0].feature_image} alt="Album-image" />
            </div>
          </div>
          {/* <div className='album-for-phone-only-exclusive1'>
          <div className='album-for-phone-only-exclusive2'>
            <div className='album-for-phone-only-exclusive3' style={{backgroundImage:`url(${circleGirl})`}}></div>
            <p className='album-for-phone-only-exclusive4-para'>Alice n’ Dolbin</p>
          </div>
          <div className='album-for-phone-only-exclusive5'>
          <TbHeartPlus style={{marginRight:"5px"}}/>
          <IoShareSocialOutline />
          </div>
        </div> */}

        </div>

        <p className='spacial-albums-for-phone-secreen-imp'>{allAlbums.length} Albums</p>
        <div>
          <div className="slider-container55">
            <div className="slider-wrapper55">
              <Slider ref={slidersssRef} {...settings}>
                {allAlbums.map((item) => (
                  <div key={item.id} className="slide-item" onClick={() => handleClick(item.id)}>
                    <div className="slider-d-jhu55">
                      <div className='podcast-hjgwqjht55'>
                        <img src={item.feature_image} alt={`Slide ${item.title}`} style={{ width: "100%", height: "100%" }} />
                      </div>
                      <p className='podcast-para-ytr44'>{item.title}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <button className="slider-arrow55 right55" onClick={() => slidersssRef.current.slickNext()}>
              <span style={{ marginRight: "5px" }}>More...</span><MdOutlineKeyboardDoubleArrowRight />
            </button>
          </div>
        </div>

        <div className='Albums-main-div2'>
          {allAlbums.slice().reverse().map((item) => (
            <div className='Albums-single-div' key={item.id} onClick={() => handleClick(item.id)}>
              <div className='albums-div-for-image'>
                <img src={item.feature_image} alt="Album-image" />
              </div>
              <p className='albums-p-para1'>{item.title}</p>
              <p className='albums-p-para2'>{item.time}</p>
            </div>
          ))}

        </div>
      </div> : <div className='layout7-div'>data not found</div>}
    </>
  )
}

export default Albums